<template>
  <div>
    <div class="col-lg-12">
      <br />
      <!-- <div class="row">
        <div class="col-lg-2">
          <el-select placeholder="Select service location" v-model="selects.servicelocation" @change="getData()"
            filterable>
            <el-option v-for="option in selects.servicelocations" class="select-info custom-option"
              :value="option.value" :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg-3 text-left">
          <el-date-picker v-model="selects.date" placeholder="Select Date" type="daterange"></el-date-picker>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="primary" @click="download()">
            <i class="fa fa-download pr-3" aria-hidden="true"></i>Download Report
          </base-button>
        </div>
      </div> -->

      <div class="d-flex flex-row align-items-center flex-wrap mx-0 py-2">
        <div class="w-25 text-left">
          <el-select
            placeholder="Select service location"
            v-model="selects.servicelocation"
            @change="getData()"
            filterable
          >
            <el-option
              v-for="option in selects.servicelocations"
              class="select-info custom-option"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            ></el-option>
          </el-select>
        </div>
        <div class="w-25 text-left">
          <el-date-picker
            v-model="selects.date"
            placeholder="Select Date"
            type="daterange"
          ></el-date-picker>
        </div>
        <div class="ml-auto text-right">
          <base-button type="primary" @click="download()">
            <i class="fa fa-download pr-3" aria-hidden="true"></i>Download
            Report
          </base-button>
        </div>
      </div>

      <br />
      <div id="authorityPage" ref="authorityPage">
        <div class="row">
          <div class="col-lg-8 d-flex">
            <card class="card-eprf">
              <div class="row">
                <div class="col-lg">
                  <p class="card-title">Ship Type</p>
                  <p style="color: #a3a3a3; font-weight: 400">
                    <i>{{ daterange }}</i>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg" v-for="(item, index) in graph" :key="index">
                  <div class="row">
                    <div class="col-lg-2">
                      <input
                        type="checkbox"
                        class="rounded-checkbox"
                        id="checkbox"
                        v-model="item.isShow"
                        @change="rearrangedata()"
                      />
                    </div>
                    <div class="col-lg">
                      <span
                        :style="item.style"
                        style="word-break: break-word; font-weight: bold"
                        >{{ item.label }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg-9">
                  <div class="chart-area">
                    <line-chart
                      v-if="shiptype.loaded"
                      :chart-data="shiptype.chartData"
                      :extra-options="shiptype.extraOptions"
                      :height="350"
                    ></line-chart>
                    <div
                      class="d-flex justify-content-center spinner"
                      v-if="!shiptype.loaded"
                    >
                      <circle-8></circle-8>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="row" style="padding-top: 40%">
                    <div class="col-lg">
                      <p
                        style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        "
                      >
                        Total Cumulative
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg">
                      <h1 style="color: #3495c6; font-size: 40px">
                        {{ totalcumulative }}
                        <span style="color: #a8a8a8; font-size: 21px"
                          >vessels</span
                        >
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <div class="row">
                <div class="col-lg-8" style="padding-top: 18%">
                  <pie-chart
                    v-if="vesselgenerated.loaded"
                    :chart-data="vesselgenerated.chartData"
                    :extra-options="vesselgenerated.extraOptions"
                    :height="250"
                  ></pie-chart>
                </div>
                <div class="col-lg-4" style="padding-top: 13%">
                  <div class="row" v-for="(item, index) in vessel" :key="index">
                    <div class="col-lg">
                      <p style="color: #4b4b4b; font-weight: 400">
                        <i
                          class="fa fa-circle"
                          aria-hidden="true"
                          :style="'color: ' + item.color"
                        ></i>
                        {{ item.title }}
                        <br />
                        <span style="color: #a9a9a9; font-size: 12px">{{
                          item.subtitle
                        }}</span>
                        <br />
                        <span style="color: #a9a9a9; font-size: 12px">{{
                          item.subtitle2
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <card class="card-eprf">
              <div class="row">
                <div class="col-lg">
                  <p class="card-title">Volume of Discharged</p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-10">
                  <div class="chart-area">
                    <bar-chart
                      v-if="volumedischarged.loaded"
                      :chart-data="volumedischarged.chartData"
                      :extra-options="volumedischarged.extraOptions"
                      :height="350"
                    ></bar-chart>
                    <div
                      class="d-flex justify-content-center spinner"
                      v-if="!volumedischarged.loaded"
                    >
                      <circle-8></circle-8>
                    </div>
                  </div>
                </div>
                <div class="col-lg">
                  <div class="row" style="padding-top: 40%">
                    <div class="col-lg">
                      <p
                        style="
                          color: #707070;
                          font-size: 21px;
                          font-weight: bold;
                        "
                      >
                        Total Cumulative
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg">
                      <h1 style="color: #3495c6; font-size: 40px">
                        {{ totalcumulativevolume }}
                        <span style="color: #a8a8a8; font-size: 21px">MT</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert, DatePicker, Select, Option } from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload } from "../../../../src/components";
import moment from "moment";
import LineChart from "@/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";
import BarChart from "src/components/Charts/BarChart";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import config from "@/config";
// import "chartjs-plugin-labels";
// Import component
import Loading from "vue-loading-overlay";

export default {
  name: "AuthoritiesOverview",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    LineChart,
    Loading,
    Circle8,
    PieChart,
    BarChart,
    html2canvas,
  },

  data() {
    return {
      graph: [],
      graphlegend: [],
      daterange: "",
      shiptype: {
        chartData: {
          labels: [],
          datasets: [
            {
              yAxisID: "y-axis-1",
              type: "line",
              label: "Vessel Generated",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [1, 2, 3, 4, 5, 6],
            },
            {
              yAxisID: "y-axis-2",
              type: "line",
              label: "Land Generated",
              fill: false,
              borderColor: "#358CCB",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#358CCB",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#358CCB",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptionslll,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
      selects: {
        date: "",
        servicelocation: "",
        servicelocations: [],
      },
      isLoading: true,
      totalcumulative: "",
      totalcumulativevolume: "",
      chartlegends: [
        {
          id: 1,
          label: "Oil tanker",
          value: true,
          style: "color: #FF6384;",
        },
        {
          id: 2,
          label: "Chemical Tanker",
          value: true,
          style: "color: #36A2EB;",
        },
        {
          id: 3,
          label: "Bulk Carrier",
          value: true,
          style: "color: #FFCE56;",
        },
        {
          id: 4,
          label: "Container",
          value: true,
          style: "color: #4BC0C0;",
        },
        {
          id: 5,
          label: "Other Cargo Ship",
          value: true,
          style: "color: #9966FF",
        },
        {
          id: 6,
          label: "Passenger Ship",
          value: true,
          style: "color: #FF9F40;",
        },
        {
          id: 7,
          label: "Roro",
          value: true,
          style: "color: #E7E9ED;",
        },
        {
          id: 8,
          label: "Others",
          value: true,
          style: "color: #A3E4D7;",
        },
      ],
      vesselgenerated: {
        chartData: {
          // "Scheduled Waste", "Garbage", "Sewage", "Scrap", "Others"
          labels: ["Scheduled Waste", "Garbage", "Sewage", "Scrap", "Others"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 5,
              // 35, 20, 5, 30, 10
              data: [35, 20, 5, 30, 10],
            },
          ],
        },
        loaded: false,
        extraOptions: {
          // plugins: {
          //   labels: {

          //     // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
          //     render: "label",

          //     // precision for percentage, default is 0
          //     precision: 0,

          //     // identifies whether or not labels of value 0 are displayed, default is false
          //     showZero: true,

          //     // font size, default is defaultFontSize
          //     fontSize: 12,

          //     // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
          //     fontColor: "#000000",

          //     // font style, default is defaultFontStyle
          //     fontStyle: "normal",

          //     // font family, default is defaultFontFamily
          //     // fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          //     fontFamily: "Poppins, sans-serif",
          //     // draw text shadows under labels, default is false
          //     textShadow: true,

          //     // text shadow intensity, default is 6
          //     shadowBlur: 0,

          //     // text shadow X offset, default is 3
          //     shadowOffsetX: -10,

          //     // text shadow Y offset, default is 3
          //     shadowOffsetY: 15,

          //     // text shadow color, default is 'rgba(0,0,0,0.3)'
          //     // shadowColor: "rgba(255,0,0,0.75)",

          //     // draw label in arc, default is false
          //     // bar chart ignores this
          //     // arc: true,

          //     // position to draw label, available value is 'default', 'border' and 'outside'
          //     // bar chart ignores this
          //     // default is 'default'
          //     position: "outside",

          //     // draw label even it's overlap, default is true
          //     // bar chart ignores this
          //     overlap: false,

          //     // show the real calculated percentages from the values and don't apply the additional logic to fit the percentages to 100 in total, default is false
          //     showActualPercentages: false,

          //     // set images when `render` is 'image'
          //     // images: [
          //     //   {
          //     //     src: "image.png",
          //     //     width: 16,
          //     //     height: 16,
          //     //   },
          //     // ],

          //     // add padding when position is `outside`
          //     // default is 2
          //     outsidePadding: 14,

          //     // add margin of text when position is `outside` or `border`
          //     // default is 2
          //     // textMargin: 4,
          //     render: (args) => {
          //       return `${args.label}: ${args.value}%`;
          //     },
          //   },
          // },
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: "right",
            labels: {
              usePointStyle: true,
              pointStyle: {
                margin: "10px",
              },
              boxWidth: 10,
              fontColor: "white",
            },
          },
          elements: {
            center: {
              text: "",
              //   color: "#000000", // Default is #000000
              fontStyle: "Poppins", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 30, // Default is 25 (in px), used for when text wraps
            },
          },
          responsive: true,
          cutoutPercentage: 85,
          tooltips: {
            enabled: true,
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
          },
          animation: {
            duration: 500,
            onProgress: function (chart) {
              if (chart.chart.config.options.elements.center) {
                // Get ctx from string
                var ctx = chart.chart.ctx;

                // Set font settings to draw it correctly.
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                var centerX =
                  (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                  2;
                var centerY =
                  (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                  2;
                // ctx.font = fontSizeToUse + "px " + fontStyle;
                // ctx.fillStyle = color;

                //Draw text in center
                ctx.font = "bold 20px Poppins, sans-serif";
                ctx.fillStyle = "#000000";
                ctx.fillText("Vessel", centerX, centerY - 10);
                ctx.fillText("generated", centerX, centerY + 15);
              }
            },
          },

          scales: {
            yAxes: [
              {
                display: 0,
                ticks: {
                  display: false,
                },
                gridLines: {
                  drawBorder: false,
                  zeroLineColor: "transparent",
                  color: "rgba(255,255,255,0.05)",
                },
              },
            ],

            xAxes: [
              {
                display: 0,
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(255,255,255,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      vessel: [
        {
          title: "Annex I",
          subtitle: "Oil mixture",
          subtitle2: "",

          color: "#3495C6",
        },
        {
          title: "Annex II",
          subtitle: "Noxious Liquid ",
          subtitle2: "Substances (NLS)",

          color: "#33BBB7",
        },
        {
          title: "Annex IV",
          subtitle: "Sewage",
          subtitle2: "",
          color: "#82ba41",
        },
        {
          title: "Annex V",
          subtitle: "Garbage",
          subtitle2: "",
          color: "#c1c1c1",
        },
        {
          title: "Annex VI",
          subtitle: "Ozone Depleting",
          subtitle2: "Substances",
          color: "#ffffff; border: 0.5px solid #c1c1c1; border-radius: 50%",
        },
      ],
      volumedischarged: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              barPercentage: 0.1,
              borderRadius: 100,
              //  pointStyle: 'circle',
              backgroundColor: "rgba(52,149,198,0.9)",
              // borderColor: config.colors.danger,
              // borderWidth: 0,
              // borderDash: [],
              // borderDashOffset: 0.5,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.barChartOptionsGradient2,
        gradientColors: config.colors.purpleGradient,
        gradientStops: [1, 0],
      },
      volumedischarged2: {
        chartData: {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
          ],
          datasets: [
            {
              label: "My Dataset",
              backgroundColor: "#42A5F5",
              data: [40, 20, 12, 39, 10, 40, 39],
              borderRadius: 10, // Set border radius for rounded corners
            },
          ],
        },
        loaded: true,
        extraOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        gradientColors: config.colors.purpleGradient,
        gradientStops: [1, 0],
      },

      selectedFileName: "",
      allfilename: [],
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,

      //data from user
      agencyname: "",
      phoneno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      email: "",
      picdepartment: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      email2: "",
      picdepartment2: "",

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      addPIC: false,

      modals: {
        successModal: false,
        failedModal: false,
      },

      swdisposed: [
        { value: "1", label1: "SW 101", label2: "300,000 MT" },
        { value: "2", label1: "SW 101", label2: "270,000 MT" },
        { value: "3", label1: "SW 101", label2: "300,000 MT" },
        { value: "4", label1: "SW 101", label2: "300,000 MT" },
        { value: "5", label1: "SW 101", label2: "300,000 MT" },
        { value: "6", label1: "SW 101", label2: "300,000 MT" },
        { value: "7", label1: "SW 101", label2: "300,000 MT" },
        { value: "8", label1: "SW 101", label2: "300,000 MT" },
        { value: "9", label1: "SW 101", label2: "300,000 MT" },
        { value: "10", label1: "SW 101", label2: "50,000 MT" },
      ],
    };
  },
  methods: {
    download() {
      // const doc = new jsPDF({
      //   orientation: "l",
      //   unit: "px",
      //   format: "a4",
      //   hotfixes: ["px_scaling"],
      // });
      // var doc = new jsPDF("l", "mm", "a4");

      // console.log(doc.internal.pageSize.getWidth())
      // console.log(doc.internal.pageSize.getHeight())
      // // document.getElementById("authorityPage").innerHTML = 
      // console.log(screen.availWidth)

      html2canvas(this.$refs.authorityPage).then((canvas) => {
        const imgData  = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: 'landscape',
        });
        const imgProps= pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        const pdfHeight = pdf.internal.pageSize.getHeight()

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('Authority.pdf');
        // doc.addImage(
        //   img,
        //   "PNG",
        //   5,
        //   5,
        //   // screen.availWidth,
        //   doc.internal.pageSize.getWidth() + 20,
        //   doc.internal.pageSize.getHeight()
        // );
        // doc.save("Authority.pdf");
      });
    },
    rearrangedata() {
      this.shiptype.loaded = false;
      this.shiptype = {};

      let label = [];
      let dataset = [];
      let sum = 0;

      label = this.graph[0].labeldata;
      for (var i = 0; i < this.graph.length; i++) {
        this.graph[i].data.forEach((el) => (sum += el));

        if (this.graph[i].isShow == true) {
          let obj = {
            type: "line",
            label: this.graph[i].label,
            fill: false,
            borderColor: this.graph[i].color,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.5,
            pointBackgroundColor: this.graph[i].color,
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: this.graph[i].color,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.graph[i].data,
          };

          dataset.push(obj);
        }
      }

      this.totalcumulative = sum;

      setTimeout(() => {
        this.shiptype = {
          chartData: {
            labels: label,
            datasets: dataset,
          },
          loaded: true,
          extraOptions: chartConfigs.purpleChartOptionslll,
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 1, 1],
        };
        this.shiptype.loaded = true;
      }, 500);
    },
    getData() {
      this.vesselgenerated.loaded = false;
      this.volumedischarged = false;
      let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = moment(this.selects.date[1]).format("YYYY-MM-DD");

      this.$http
        .get(
          ":10001/api/v1/authority?start_date=" +
            start +
            "&end_date=" +
            end +
            "&service_location_id=" +
            this.selects.servicelocation
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            let ar = [];
            for (var i = 0; i < response.graph.line_graph.data.length; i++) {
              let arrr = {
                title: response.graph.line_graph.data[i].ship_name,
                isShow: true,
                data: response.graph.line_graph.data[i].value,
                color: response.graph.line_graph.color[i],
                labeldata: response.graph.line_graph.label,
                label: response.graph.line_graph.data[i].ship_name,
                style: "color: " + response.graph.line_graph.color[i] + ";",
              };
              ar.push(arrr);
            }

            this.graph = ar;
            this.rearrangedata();

            // marshall pie chart
            this.vesselgenerated = {
              chartData: {
                // "Scheduled Waste", "Garbage", "Sewage", "Scrap", "Others"
                labels: response.vessel_generated.label,
                datasets: [
                  {
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    backgroundColor: response.vessel_generated.color,
                    borderWidth: 5,

                    data: response.vessel_generated.data,
                  },
                ],
              },
              loaded: true,
              extraOptions: {
                maintainAspectRatio: false,
                legend: {
                  display: false,
                  position: "right",
                  labels: {
                    usePointStyle: true,
                    pointStyle: {
                      margin: "10px",
                    },
                    boxWidth: 10,
                    fontColor: "white",
                  },
                },
                elements: {
                  center: {
                    text: "",
                    //   color: "#000000", // Default is #000000
                    fontStyle: "Poppins", // Default is Arial
                    sidePadding: 20, // Default is 20 (as a percentage)
                    minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                    lineHeight: 30, // Default is 25 (in px), used for when text wraps
                  },
                },
                responsive: true,
                cutoutPercentage: 85,
                tooltips: {
                  enabled: true,
                  backgroundColor: "#f5f5f5",
                  titleFontColor: "#333",
                  bodyFontColor: "#666",
                  bodySpacing: 4,
                  xPadding: 12,
                  mode: "nearest",
                  intersect: 0,
                  position: "nearest",
                },
                animation: {
                  duration: 500,
                  onComplete: function (chart) {
                    if (chart.chart.config.options.elements.center) {
                      // Get ctx from string
                      var ctx = chart.chart.ctx;

                      ctx.textAlign = "center";
                      ctx.textBaseline = "middle";
                      var centerX =
                        (chart.chart.chartArea.left +
                          chart.chart.chartArea.right) /
                        2;
                      var centerY =
                        (chart.chart.chartArea.top +
                          chart.chart.chartArea.bottom) /
                        2;

                      //Draw text in center
                      ctx.font = "bold 20px Poppins, sans-serif";
                      ctx.fillStyle = "#000000";
                      ctx.fillText("Vessel", centerX, centerY - 10);
                      ctx.fillText("generated", centerX, centerY + 15);
                    }
                  },
                },

                scales: {
                  yAxes: [
                    {
                      display: 0,
                      ticks: {
                        display: false,
                      },
                      gridLines: {
                        drawBorder: false,
                        zeroLineColor: "transparent",
                        color: "rgba(255,255,255,0.05)",
                      },
                    },
                  ],

                  xAxes: [
                    {
                      display: 0,
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(255,255,255,0.1)",
                        zeroLineColor: "transparent",
                      },
                      ticks: {
                        display: false,
                      },
                    },
                  ],
                },
              },
            };
            this.vessel = [];
            for (var i = 0; i < response.vessel_generated.label.length; i++) {
              let obj = {
                title: response.vessel_generated.label[i],
                // subtitle: "Oil mixture",
                // subtitle2: "",

                color: response.vessel_generated.color[i],
              };
              this.vessel.push(obj);
            }

            // marshall bar chart
            // 80, 100, 70, 80, 120, 80
            let bardata = [];
            let barlabel = [];

            for (var i = 0; i < response.graph.histogram.length; i++) {
              // response.graph.histogram[i].data.weight
              bardata.push(response.graph.histogram[i].data.weight);
              barlabel.push(response.graph.histogram[i].month_name);
            }

            this.totalcumulativevolume = bardata.reduce(
              (partialSum, a) => partialSum + a,
              0
            );

            // var gradient = ctx.createLinearGradient(0, 0, 0, 400);
            // gradient.addColorStop(0, "rgba(250,174,50,1)");
            // gradient.addColorStop(1, "rgba(250,174,50,0)");

            this.volumedischarged = {
              chartData: {
                labels: barlabel,
                datasets: [
                  {
                    label: "Total",
                    barPercentage: 0.3,
                    // borderColor: "#FC2525",
                    // pointBackgroundColor: "white",
                    borderRadius: 10,
                    borderWidth: 0.3,
                    radius: 5,

                    fill: true,
                    // pointBorderColor: "white",
                    backgroundColor: (ctx) => {
                      const canvas = ctx.chart.ctx;
                      const gradient = canvas.createLinearGradient(
                        0,
                        0,
                        0,
                        160
                      );

                      gradient.addColorStop(0, "#3495C6");
                      // gradient.addColorStop(0.5, "cyan");
                      gradient.addColorStop(1, "#EFF0F1");

                      return gradient;
                    },
                    tension: 0.25,
                    data: bardata,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.barChartOptionsGradient2,
              gradientColors: config.colors.purpleGradient,
              gradientStops: [1, 0],
            };
          }
          // console.log(arr);
        });
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    toggleShow3() {
      this.showPassword3 = !this.showPassword3;
    },

    addCard() {
      this.addPIC = true;
    },
    cancelAddCard() {
      this.addPIC = false;
    },
    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },
    getLogin() {
      this.$router.push("/Vendor/Job");
      console.log("hoi");
    },
    onFileChange(event) {
      const input = event.target;
      if (input.files.length > 0) {
        for (let i = 0; i < input.files.length; i++) {
          this.selectedFileName = input.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
      } else {
        this.selectedFileName = "";
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    getServiceLocation() {
      this.selects.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };
            this.selects.servicelocations.push(obj);
          }
        }
      });
    },
  },
  watch: {
    "selects.date"() {
      console.log(this.selects.date);
      this.daterange =
        moment(this.selects.date[0]).format("MMM") +
        "-" +
        moment(this.selects.date[1]).format("MMM YYYY");

      this.getData();
    },
  },
  created() {
    this.getServiceLocation();
    this.selects.date = [
      moment().startOf("y").format("YYYY-MM-DD"),
      moment().endOf("y").format("YYYY-MM-DD"),
    ];
  },
  computed: {
    // buttonLabel() {
    //   return this.showPassword ? "Hide" : "Show";
    // },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #358CCB;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
}

.number {
  color: white;
}
</style>
